import React from 'react';
import Box from '@amzn/meridian/box';
import Heading from '@amzn/meridian/heading';
import Text from '@amzn/meridian/text';

const ReviewAndPublishPage: React.FC = () => (
  <Box spacingInset="400">
    <Heading level={2}>Review and Publish</Heading>
    <Text>This page is under construction.</Text>
  </Box>
);

export default ReviewAndPublishPage;
